import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc56ac50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cc56ac50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc56ac50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc56ac50')) {
      api.createRecord('cc56ac50', component.options)
    } else {
      api.reload('cc56ac50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cc56ac50&scoped=true", function () {
      api.rerender('cc56ac50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/componentUserRoles/index.vue"
export default component.exports